<div class="d-action-panel" (window:resize)="doAdapt()">
  <nav class="tabs adaptive-buttons">
    <ul class="-primary">
      <ng-content></ng-content>
    </ul>
  </nav>
</div>